// One assign flow at a time. It starts when the teacher first selects work to
// assign and resets once nothing is left to assign (assigned or cleared), so
// confirmation can report the time since the flow started.
let flowStartedAt = null;

export function startAssignmentFlow(now = Date.now()) {
  if (flowStartedAt !== null) return false;
  flowStartedAt = now;
  return true;
}

export function resetAssignmentFlow() {
  flowStartedAt = null;
}

export function getAssignmentFlowDurationMs(now = Date.now()) {
  return flowStartedAt === null ? undefined : now - flowStartedAt;
}



// WEBPACK FOOTER //
// ./analytics/tracking/assignment-flow.js